import { render, staticRenderFns } from "./player-topbar.vue?vue&type=template&id=44359274"
import script from "./player-topbar.vue?vue&type=script&lang=js"
export * from "./player-topbar.vue?vue&type=script&lang=js"
import style0 from "./player-topbar.vue?vue&type=style&index=0&id=44359274&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports